const OrganismFooter = () => {
  return (
    <footer className="footer max-width-1600px">
      <p>Crafted with caffeine, curiosity, and a love for CSS ✨</p>
      <p>Open to freelance or full-time front-end roles • Based in Québec</p>
      <p>
        Say hi 👋 <a href="mailto:your@email.com">your@email.com</a>
      </p>
    </footer>
  );
};

export default OrganismFooter;
